import React from "react";
import DocumentVenteEntity from "./DocumentVenteEntity";

const Devis = () => {
    return <DocumentVenteEntity type="Devis" title="Devis" endpoint="DevisVente" />;
};

export default Devis;
